import React, { useState, useEffect } from "react";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { useParams } from "react-router-dom";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import noproduct from "../component/img/product_not_found.jpeg";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet"; // Import Helmet for managing SEO tags
import BlogFilter from "../component/BlogFilter";
import { ChevronRight } from "react-feather";

const BlogDetail = () => {
  const { slug } = useParams(); // Get the slug from the URL parameters
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    // Fetch the blog by slug
    axios
      .get(`${baseurl}GetBlogBySlug/${slug}`)
      .then((res) => {
        setBlog(res.data);
      })
      .catch((err) => {
        console.error("Error fetching blog:", err);
      });
  }, [slug]); // Refetch if the slug changes

  if (!blog) {
    return (
      <div className="text-center">
        <img src={noproduct} alt="Loading" style={{ width: "250px" }} />
        <p className="mt-2 text-muted">Loading blog details...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        {/* Dynamically update SEO tags */}
        <title>{blog.title_tag || blog.title}</title>
        <meta
          name="description"
          content={blog.meta_description || "Default description"}
        />
        <meta
          name="keywords"
          content={blog.meta_keywords || "Default, keywords"}
        />
        {/* Schema markup (if available in the blog data) */}
        {blog.schema_markup && (
          <script type="application/ld+json">{blog.schema_markup}</script>
        )}
      </Helmet>

      <VisitorNavbar />
      <div className="container-fluid py-1">
        <div className="text-start brdcrm1 mb-3">
          <span>Home</span>
          <span>
            <ChevronRight size={12} />
          </span>
          <span>Blogs</span>
          <span>
            <ChevronRight size={12} />
          </span>

          <span>{blog.title}</span>
        </div>

        <div className="row g-5">
          <div className="col-md-8">
            <div className="border-0">
              <img
                src={
                  blog.thumbnail
                    ? `${imageUrl}blog/${blog.thumbnail}`
                    : noproduct
                }
                alt={blog.title}
                className="card-img-top"
                style={{
                  height: "350px",
                  objectFit: "cover",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                }}
              /> 

              <div class="blog-meta text-start mt-2"><span>By {blog.author_name || "Admin"}</span><span>📅  {new Date(blog.published_at).toLocaleDateString()}</span></div>

               
              <div className="  text-start">
                <small className="text-primary fw-semibold">
                  {blog.category_name}
                </small>
                <h2 className="mt-3 fw-bold">{blog.title}</h2>
                
                <div
                  className="mt-3"
                  dangerouslySetInnerHTML={{ __html: blog.content }} // Render the content as HTML
                />
              </div>
              {/* <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center">
                <Link to="/blogs" className="btn btn-outline-primary btn-sm">Back to Blogs</Link>
              </div> */}
            </div>


            <section className="comment-section text-start">
            <div className="comment-container">
              <h2 className="comment-title">Leave A Comment</h2>
              <p className="comment-note">Fields (*) Mark are Required</p>

              <form
                className="comment-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  alert("Comment submitted!");
                }}
              >
                <div className="input-row">
                  <input type="text" name="name" placeholder="Full Name*" required />
                  <input type="email" name="email" placeholder="Email Address*" required />
                </div>

                <input type="url" name="website" placeholder="https://" />

                <textarea name="comment" placeholder="Your Comment*" required />

                <button type="submit">Submit Comment →</button>
              </form>

            </div>
          </section>


          </div>

          <div className="col-md-4">
            <BlogFilter slug={blog.slug} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogDetail;
